<div
  *ngIf="showMessage && event"
  [@fadeInOut]
  (@fadeInOut.start)="onAnimationStart($event)"
  (@fadeInOut.done)="onAnimationDone($event)"
  class="alert-container"
  [ngClass]="{
    donation: event.type === 'donation',
    sale: event.type === 'sale',
    'position-top': alertPosition === 'top',
    'position-center': alertPosition === 'center',
    'position-bottom': alertPosition === 'bottom'
  }"
>
  <!-- Logo ou GIF -->
  <div class="alert-logo">
    <img src="assets/gifs/rhyno.gif" alt="Alerta" />
  </div>

  <!-- Conteúdo -->
  <div class="alert-content">
    <!-- 🎯 TEMPLATE SEPARADO (Nova estrutura) -->
    <div *ngIf="useSeparateTemplate" class="alert-message-separated">
      <div class="alert-main-text">{{ mainText }}</div>
      <div class="alert-user-message" *ngIf="userMessage">{{ userMessage }}</div>
    </div>
    
    <!-- 🔄 TEMPLATE LEGADO (Compatibilidade) -->
    <div *ngIf="!useSeparateTemplate" class="alert-message">
      {{ message }}
    </div>
  </div>
</div>
